import { Link } from 'react-router-dom';
import type { QuickActionSpec } from '../../exechome/framework';

type Props = {
  actions: QuickActionSpec[];
};

export function QuickActionsBar({ actions }: Props) {
  return (
    <div className="flex flex-wrap gap-2" role="toolbar" aria-label="Quick actions">
      {actions.map((a) => (
        <Link
          key={a.action}
          to={a.path ?? '#'}
          className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-medium text-slate-700 transition hover:border-brand-300 hover:bg-brand-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-brand-700 dark:hover:bg-brand-950"
        >
          {a.label}
        </Link>
      ))}
    </div>
  );
}
